import { useEffect, useState } from "react";

// Landing pad for the OAuth 2.0 authorization-code (PKCE) popup.
// The IdP redirects here with ?code=…&state=…; we relay both to the
// window that opened us (AuthEditor listens for this message) and
// close. All token exchange happens in the opener + API — this page
// never sees credentials beyond the one-time code.
export default function OAuthCallback() {
  const [status, setStatus] = useState<"relaying" | "done" | "error">("relaying");
  const [detail, setDetail] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");
    const code = params.get("code");
    const state = params.get("state");
    if (error) {
      setStatus("error");
      setDetail(params.get("error_description") || error);
      return;
    }
    if (!code || !state) {
      setStatus("error");
      setDetail("Missing code or state in the callback URL.");
      return;
    }
    if (window.opener) {
      window.opener.postMessage(
        { type: "apistash:oauth_code", code, state },
        window.location.origin,
      );
      setStatus("done");
      // Give the opener a beat to receive before closing.
      const t = setTimeout(() => window.close(), 400);
      return () => clearTimeout(t);
    }
    setStatus("error");
    setDetail("This window wasn't opened by API Stash — start the sign-in from the request's Auth tab.");
  }, []);

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="card p-6 max-w-md text-center space-y-2">
        {status === "relaying" && <p className="text-sm">Completing sign-in…</p>}
        {status === "done" && (
          <>
            <p className="text-sm font-medium">Signed in ✓</p>
            <p className="text-xs muted">You can close this window.</p>
          </>
        )}
        {status === "error" && (
          <>
            <p className="text-sm font-medium text-danger">Sign-in failed</p>
            <p className="text-xs muted">{detail}</p>
          </>
        )}
      </div>
    </div>
  );
}
